export default "__VITE_ASSET__Cgg1OR$N__"